var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Page',{attrs:{"total":_vm.value.total,"current":_vm.value.currentPage,"page-size":_vm.value.perPage,"show-sizer":"","page-size-opts":_vm.perPageOpts,"show-total":""},on:{"on-change":val => _vm.onChangePage(val),"on-page-size-change":val => _vm.onChangePerPage(val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }